import React, { useState } from "react";
import { FaChevronDown, FaCheck } from "react-icons/fa";

const TabNavigation = ({ resultTab1, totalResults ,setSelectedSort }) => {
  const [activeTab, setActiveTab] = useState("Properties");
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedSort, setSortOption] = useState("Relevance");

  const sortOptions = [
    "Relevance",
    "Price - Low to High",
    "Price - High to Low",
    "Most Recent",
  ];

  const handleSortChange = (option) => {
    setSortOption(option);
    setSelectedSort(option); // **Update sorting in parent component**
    setDropdownOpen(false);
  };


  return (
    <div className="flex items-center justify-between border-b border-gray-300 relative">
      {/* Tabs */}
      <div className="flex space-x-4">
        {["Properties", ].map((tab) => (
          <button
            key={tab}
            className={`px-4 py-2 text-sm rounded-t-[10px] font-medium border ${
              activeTab === tab
                ? "text-red-600 border-red-600 border-b-4"
                : "text-gray-600 hover:text-red-600 focus:border-b-4 focus:border-red-600"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === "Properties" ? resultTab1 || "Properties" : tab}
            {tab === "Properties" && (
              <span className="font-semibold"> ({totalResults || 0}+)</span>
            )}
          </button>
        ))}
      </div>

      {/* Sort By Dropdown */}
      <div className="relative">
        <button
          onClick={() => setDropdownOpen(!isDropdownOpen)}
          className="border border-gray-300 rounded-t-md px-4 py-2 text-sm text-gray-600 flex items-center space-x-2 min-w-[200px]"
        >
          <span>Sort by: {selectedSort}</span>
          <FaChevronDown className="text-gray-500" />
        </button>

        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 w-[250px] bg-white shadow-lg rounded-lg border border-gray-300 z-10">
            {sortOptions.map((option) => (
              <div
                key={option}
                className={`px-4 py-2 flex justify-between items-center cursor-pointer hover:bg-gray-100 ${
                  selectedSort === option ? "font-semibold text-red-600" : ""
                }`}
                onClick={() => handleSortChange(option)}
              >
                <span>{option}</span>
                {selectedSort === option && <FaCheck className="text-red-600" />}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TabNavigation;
